import { Box, Checkbox, useSlotRecipe } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { SearchEngineInstantReservationCheckboxProps } from './search-engine-instant-reservation-checkbox.props';

import { defaultSearchEngineTranslation } from '../../../models';

export const SearchEngineInstantReservationCheckbox = ({
    setValue,
    onInputValueUpdated,
    translationData = defaultSearchEngineTranslation,
    watch,
    withBackground = false,
    ...props
}: SearchEngineInstantReservationCheckboxProps) => {
    const recipe = useSlotRecipe({ key: 'searchEngineInstantReservationCheckbox' });
    const styles = recipe({
        variant: withBackground ? 'withBg' : undefined,
    });

    return (
        <Checkbox.Root
            checked={watch('instantReservation')}
            onCheckedChange={details => {
                setValue('instantReservation', !!details.checked);
                onInputValueUpdated();
            }}
            data-testid="search-engine-instant-reservation-checkbox"
            alignItems={'flex-start'}
            size={'lg'}
            css={styles.root}
            {...props}
        >
            <Checkbox.HiddenInput />
            <Checkbox.Control />
            <Checkbox.Label
                fontSize={{
                    base: 'xs',
                    md: 'md',
                }}
                lineHeight={1.5}
            >
                <Box fontWeight={'700'}>
                    {translationData.instantReservationLabel}
                    <IconsLinear.Flash
                        color={'selectiveYellow'}
                        fill={'selectiveYellow'}
                        ml={{
                            base: 1,
                            md: 2,
                        }}
                    />
                </Box>
                <Box color={'green.800'}>{translationData.instantReservationDescription}</Box>
            </Checkbox.Label>
        </Checkbox.Root>
    );
};
